"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var companySwitcherStyle = {
  option: function option(provided, state) {
    return _objectSpread({}, provided, {
      backgroundColor: null,
      color: state.isSelected ? '#151C23' : '#757575',
      fontWeight: state.isSelected ? '500' : 'normal',
      fontSize: '1.3rem',
      lineHeight: '3.2rem',
      padding: '0px 16px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#F3F4F5',
        color: '#151C23'
      }
    });
  },
  menu: function menu(provided, _state) {
    return _objectSpread({}, provided, {
      marginTop: '0px',
      borderRadius: 0,
      cursor: 'pointer',
      boxShadow: '0px 8px 16px rgba(0,0,0,.16)',
      borderTop: '1px solid #D6D8DC'
    });
  },
  control: function control(provided, _state) {
    return _objectSpread({}, provided, {
      borderRadius: 0,
      borderWidth: 0,
      boxShadow: 'none',
      borderTop: '1px solid #D6D8DC',
      '&:hover': {
        borderTop: '1px solid #D6D8DC'
      }
    });
  },
  input: function input(provided) {
    return _objectSpread({}, provided, {
      marginLeft: '48px',
      marginBottom: '0px',
      '&:focus': {
        boxShadow: 'none'
      }
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread({}, provided, {
      height: '48px',
      padding: '0px',
      margin: '0px'
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread({}, provided, {
      marginLeft: '0px',
      marginRight: '0px',
      marginTop: '2px'
    });
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      display: 'none'
    };
  }
};
var _default = companySwitcherStyle;
exports.default = _default;